import * as React from 'react';

const ourDataSmall = (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect width="20" height="20" rx="4" fill="white" />
    <path
      d="M7.48584 4.48619C7.48584 2.84009 9.17334 1.73369 10.6829 2.39003L17.4504 5.3324C17.7842 5.47754 18.0001 5.80686 18.0001 6.17086V16.0857C18.0001 17.348 16.9767 18.3714 15.7144 18.3714H9.77155C8.50919 18.3714 7.48584 17.348 7.48584 16.0857V4.48619Z"
      fill="url(#paint0_linear_23086_12626)"
    />
    <path
      d="M11.1426 9.9674C11.1426 8.3225 9.45734 7.21611 7.94806 7.87013L2.5505 10.2091C2.21614 10.354 1.99975 10.6836 1.99975 11.048V16.0858C1.99975 17.3482 3.02309 18.3715 4.28545 18.3715H8.85687C10.1192 18.3715 11.1426 17.3482 11.1426 16.0858V9.9674Z"
      fill="url(#paint1_linear_23086_12626)"
    />
    <defs>
      <linearGradient
        id="paint0_linear_23086_12626"
        x1="16.3451"
        y1="15.5613"
        x2="2.25538"
        y2="12.4032"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#2744FF" />
        <stop offset="1" stop-color="#B9D5FF" />
      </linearGradient>
      <linearGradient
        id="paint1_linear_23086_12626"
        x1="4.41991"
        y1="15.2586"
        x2="17.7259"
        y2="9.04764"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#BDD1E7" />
        <stop offset="1" stop-color="white" />
      </linearGradient>
    </defs>
  </svg>
);

export default ourDataSmall;
